import React from 'react'
import { Link } from 'react-router-dom'

// Where to go after a last-owner refusal (409 organization.last_owner or
// account.last_owner). Each builder takes the organizations the refusal
// names ({id, name}) and the page's form, and answers [{to, text}].

// An organization's own pages: its user list is where someone else becomes
// an owner.
export const orgUserListLinks = () => [{ to: '/org/user/list', text: 'Make someone else an owner' }]

// Sys pages: each organization the refusal names.
export const sysOrganizationLinks = organizations => organizations.map(o => ({ to: `/admin/organization/list/edit/${o.id}`, text: o.name }))

// Sys membership removal: the refusal names no organization; the membership
// being removed is in one.
export const sysMembershipLinks = (organizations, form) =>
  organizations.length
    ? sysOrganizationLinks(organizations)
    : form && form.organizationID ? [{ to: `/admin/organization/list/edit/${form.organizationID}`, text: form.organizationName || 'the organization' }] : []

export const RefusalLinks = ({ links }) =>
  links && links.length > 0
    ? <span className="ms-1">
        {links.map((link, i) =>
          <React.Fragment key={link.to}>
            {i > 0 && ', '}
            <Link to={link.to}>{link.text}</Link>
          </React.Fragment>
        )}
      </span>
    : null
